<template>
  <div class="col-12">
    <div class="row">
      <div class="col-12 margin-bottom-15 margin-left-15">
        <button class="btn btn-warning" @click="$router.go(-1)">Go back</button>
      </div>
      <div class="col-12">
        <EnglishCentralGame :dialog="dialog"/>
      </div>
    </div>
  </div>
</template>
<script>
import { EnglishCentralGame } from 'src/components/Games'
import { cloneDeep } from 'lodash'

import { toArray, toArrayWithoutId } from './../../../../store/firebase'

export default {
  name: 'EnglishCentral',
  computed: {
    subTopic() {
      return this.$store.getters['subTopic/get']
    },
    dialog () {
      return this.subTopic.dialog
    }
  },
  components: {
    EnglishCentralGame
  }
}
</script>
<style lang="scss" scoped>
</style>
